module.exports = __webpack_public_path__ + "media/images/bg-about-0fc202dd8b480732a75325d09da5f218.png";